import React from 'react';

function Loading() {
  return (
    <div className="spinner-loading" />
  );
}

export default Loading;
